// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"506":"95224560","540":"e330f5da","717":"25fae755","899":"3fb836bb"}[chunkId] + ".chunk.js";
};